import PhysicalAssetKindBasic from 'components/Kiosk/components/PhysicalAssetKind/BasicAsset';
import PhysicalAssetKindTerminal from 'components/Kiosk/components/PhysicalAssetKind/Terminal';

export const PHYSICAL_ASSET_KIND = {
  0: 'Unknown',
  1: 'Terminal',
  2: 'Kiosk Base',
  3: 'Kiosk Faceplate',
  4: 'iPad',
  unknown: 0,
  terminal: 1,
  kiosk_base: 2,
  kiosk_faceplate: 3,
  ipad: 4
};
export const PHYSICAL_ASSET_KIND_OPTIONS = [
  { label: 'Terminal', value: PHYSICAL_ASSET_KIND.terminal },
  { label: 'Kiosk Base', value: PHYSICAL_ASSET_KIND.kiosk_base },
  { label: 'Kiosk Faceplate', value: PHYSICAL_ASSET_KIND.kiosk_faceplate },
  { label: 'iPad', value: PHYSICAL_ASSET_KIND.kiosk_faceplate }
];
export const PHYSICAL_ASSET_KIND_COMPONENTS = {
  [PHYSICAL_ASSET_KIND.unknown]: PhysicalAssetKindBasic, //() => <div>Please select an asset type.</div>,
  [PHYSICAL_ASSET_KIND.terminal]: PhysicalAssetKindTerminal,
  [PHYSICAL_ASSET_KIND.kiosk_base]: PhysicalAssetKindBasic,
  [PHYSICAL_ASSET_KIND.kiosk_faceplate]: PhysicalAssetKindBasic,
  [PHYSICAL_ASSET_KIND.ipad]: PhysicalAssetKindTerminal
};
export const KIOSK_SAFE_COMMANDS = [
  { name: 'Enable Terminal Pairing', value: 'pair-terminal', data: {} },
  { name: 'Disable Terminal Pairing', value: 'pair-terminal-exit', data: {} },
  { name: 'Set Terminal Timeout', value: 'set-timeout-terminal', data: {} },
  { name: 'Payroc Bluetooth List', value: 'payroc-bt-list', data: {} },
  { name: 'Payroc Bluetooth Force Fresh Scan', value: 'payroc-bt-scan', data: {} },
  { name: 'Exit App', value: 'exit-app', data: {} }
];
